<div [id]="dbContent"></div>
<div *ngIf="!currentTab || !currentTab.groups.length">
  <div>
    <p>Please select some graphs you want to see here.</p>
    <p>Use this <i class="far fa-star"></i> at top right corner of each graph to place the graph into the dashboard.
    </p>
  </div>
</div>
